<template>
  <div
      class="absolute left-0 top-0 h-[114px] w-full overflow-hidden pointer-events-none [&_svg]:h-full [&_svg]:w-full [&_svg]:object-cover"
      :class="topBg"
      v-html="waveTopSvg"
    />
    <div
      class="absolute left-0 bottom-0 h-[114px] w-full overflow-hidden pointer-events-none [&_svg]:h-full [&_svg]:w-full [&_svg]:object-cover"
      :class="bottomBg"
      v-html="waveBottomSvg"
    />
</template>

<script setup lang="ts">
import waveTopSvg from "~/assets/images/landing/wave.svg?raw";
import waveBottomSvg from "~/assets/images/landing/wave-bottom.svg?raw";

withDefaults(
  defineProps<{
    topBg?: string;
    bottomBg?: string;
  }>(),
  { topBg: "bg-white", bottomBg: "bg-white" }
);
</script>
